import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Dialog,
  withMobileDialog,
  // DialogTitle,
  DialogContent,
  // DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core'
import { toggleEmailDialog } from 'actions/inbox'

export default connect(
  (state) => ({ emailDialog: state.inbox.emailDialog }),
  (dispatch) => bindActionCreators({ toggleEmailDialog }, dispatch),
)(
  withMobileDialog()(({ emailDialog, fullScreen, toggleEmailDialog }) => (
    <Dialog fullScreen={fullScreen} open={Boolean(emailDialog)}>
      <DialogContent>
        {emailDialog ? (
          <div dangerouslySetInnerHTML={{ __html: emailDialog }} />
        ) : 'No content'}
        {/* {emailDialog ? (
          <div>{emailDialog}</div>
        ) : 'No content'} */}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => toggleEmailDialog(null)}>Close</Button>
      </DialogActions>
    </Dialog>
  )),
)
